import { BIRDVIEW_ATTENTION_AGE_OPTIONS } from '../../DashboardBirdview.constants.attention'
import { getBirdviewAgeRangeLabelParams } from '../../DashboardBirdview.utils.charts'

export function getBirdviewAttentionAgeOptions(t) {
  return BIRDVIEW_ATTENTION_AGE_OPTIONS.map(option => ({
    ...option,
    label: t(option.labelKey, getBirdviewAgeRangeLabelParams(option)),
  }))
}
